<a class="file cursor-text">
  <i class="icon ic-xs ic-file"></i>
  <span>{{ fileName }}</span>
</a>
